<template>
  <!-- begin:: Header -->
  <div id="kt_header" class="kt-header kt-grid kt-grid--ver kt-header--fixed">
    <!-- begin:: Aside -->
    <div class="kt-header__brand kt-grid__item" id="kt_header_brand">
      <div class="kt-header__brand-logo">
        <router-link to="/home">
          <img alt="Logo" src="/img/logo-6.png" />
        </router-link>
      </div>
    </div>

    <!-- end:: Aside -->
    <!-- begin:: Title -->
    <h3 class="kt-header__title kt-grid__item">{{ $t("WebsiteName") }}</h3>
    <!-- end:: Title -->
    <!-- begin: Header Menu -->
    <button
      class="kt-header-menu-wrapper-close"
      id="kt_header_menu_mobile_close_btn"
      @click="sendMessage"
    >
      <i class="la la-close"></i>
    </button>
    <div
      class="kt-header-menu-wrapper kt-grid__item kt-grid__item--fluid"
      id="kt_header_menu_wrapper"
    >
      <div
        id="kt_header_menu"
        class="kt-header-menu kt-header-menu-mobile kt-header-menu--layout-default"
      >
        <ul class="kt-menu__nav">
          <li class="kt-menu__item" aria-haspopup="true">
            <router-link to="/home" class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("Home") }}</span>
            </router-link>
          </li>
          <li class="kt-menu__item" aria-haspopup="true">
            <router-link to="/profile" class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("Profile") }}</span>
            </router-link>
          </li>
          <li
            class="kt-menu__item"
            aria-haspopup="true"
            v-if="version !== 'X.XX.X'"
          >
            <a
              :href="`/app/cashier-app-${version}-win-x64.zip`"
              class="kt-menu__link"
            >
              <span class="kt-menu__link-text"
                >{{ $t("Cashier App") }} v{{ version }}</span
              >
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- end: Header Menu -->
    <!-- begin:: Header Topbar -->
    <div class="kt-header__topbar">
      <div class="kt-header__topbar-item kt-header__topbar-item--langs">
        <b-dropdown
          variant="noop"
          toggle-class="no-padding"
          :menu-class="[
            'dropdown-menu-anim',
            'custom-dropdown-menu',
            'notifications-menu',
          ]"
          no-caret
          right
          id="bv-dropdown-notifications"
        >
          <template slot="button-content">
            <div class="kt-header__topbar-wrapper">
              <span
                class="kt-header__topbar-icon kt-header__topbar-icon--brand"
                style="position: relative"
              >
                <i class="icon-bell" style="padding-right: 0" />
                <span
                  class="kt-badge kt-badge--danger"
                  v-if="newNotifications != 0"
                  style="position: absolute; zoom: 0.7; top: 6px; right: 6px"
                  >{{ newNotifications }}</span
                >
              </span>
            </div>
          </template>
          <b-dropdown-text style="width: 400px">
            <!--begin: Head -->
            <div
              class="kt-head kt-head--skin-dark kt-head--fit-x kt-head--fit-b"
              style="background-image: url(/img/misc/bg-1.jpg)"
            >
              <h3 class="kt-head__title" style="padding-bottom: 2.5rem">
                {{ $t("Ticket Authorization Alerts") }}
                &nbsp;
                <span
                  class="btn btn-success btn-sm btn-bold btn-font-md"
                  :class="{ 'mr-3': notifications.length != 0 }"
                  >{{ notifications.length }} {{ $t("new") }}</span
                >
                <span
                  @click.stop="clearNotifications"
                  v-if="notifications.length != 0"
                  class="btn btn-danger btn-sm btn-bold btn-font-md"
                  style="padding: 0.5rem 0.7rem; cursor: pointer"
                >
                  <i class="flaticon-delete" style="padding-right: 0.1rem" />
                </span>
              </h3>
            </div>
            <!--end: Head -->
            <!--begin: Navigation -->
            <div
              class="kt-notification kt-margin-t-10 kt-margin-b-10"
              style="max-height: 400px; overflow: auto"
            >
              <router-link
                v-for="item in notifications"
                :key="item.ticket_id"
                :to="`/ticket-authorizations/${item.authz_id}`"
                class="kt-notification__item"
              >
                <div class="kt-notification__item-icon">
                  <i class="icon-calendar kt-font-success"></i>
                </div>
                <div class="kt-notification__item-details">
                  <div class="kt-notification__item-title kt-font-bold">
                    {{ item.ticket_serial }}
                  </div>
                  <div class="kt-notification__item-time">
                    <span v-if="item.type == 1">{{ $t("authorization") }}</span>
                    <span v-if="item.type == 2">{{ $t("reprint") }}</span>
                    -
                    <MomentsAgo
                      prefix="received"
                      :date="mom_unix(item.queue_time).format()"
                      :lang="lang"
                    />
                  </div>
                </div>
                <i class="icon-arrow-right" style="color: #a7abc3" />
              </router-link>
              <div
                class="kt-grid kt-grid--ver"
                style="min-height: 200px"
                v-if="notifications.length == 0"
              >
                <div
                  class="kt-grid kt-grid--hor kt-grid__item kt-grid__item--fluid kt-grid__item--middle"
                >
                  <div
                    class="kt-grid__item kt-grid__item--middle kt-align-center"
                  >
                    {{ $t("No new notifications.") }}
                  </div>
                </div>
              </div>
            </div>
            <!--end: Navigation -->
          </b-dropdown-text>
        </b-dropdown>
      </div>

      <!--begin: Language bar -->
      <div class="kt-header__topbar-item kt-header__topbar-item--langs">
        <b-dropdown
          variant="noop"
          toggle-class="no-padding"
          menu-class="dropdown-menu-anim"
          no-caret
          right
        >
          <template slot="button-content">
            <div class="kt-header__topbar-wrapper">
              <span
                class="kt-header__topbar-icon kt-header__topbar-icon--brand"
              >
                <div
                  class="flag-icon flag-header"
                  :class="flag"
                  style="display: inline-block"
                  :title="$t('Change language')"
                ></div>
              </span>
            </div>
          </template>
          <b-dropdown-header>
            <strong style="font-size: 1rem">{{ $t("Change language") }}</strong>
          </b-dropdown-header>
          <b-dropdown-item class="kt-nav__link" @click="changeLang('ro')">
            <span class="kt-nav__link-icon">
              <div class="flag-icon flag-icon-ro"></div>
            </span>
            <span class="kt-nav__link-text">{{ $t("Romanian") }}</span>
          </b-dropdown-item>
          <b-dropdown-item class="kt-nav__link" @click="changeLang('en')">
            <span class="kt-nav__link-icon">
              <div class="flag-icon flag-icon-gb"></div>
            </span>
            <span class="kt-nav__link-text">{{ $t("English") }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="kt-header__topbar-item kt-header__topbar-item--user">
        <b-dropdown
          variant="noop"
          toggle-class="no-padding"
          :menu-class="['dropdown-menu-anim', 'custom-dropdown-menu']"
          no-caret
          right
          ref="dropdown"
        >
          <template slot="button-content">
            <div class="kt-header__topbar-wrapper">
              <span
                class="kt-header__topbar-icon kt-header__topbar-icon--brand"
              >
                <i class="icon-user" style="padding-right: 0" />
              </span>
            </div>
          </template>
          <!--b-dropdown-header>
            <strong>{{$t('Account')}}</strong>
          </b-dropdown-header-->
          <b-dropdown-text style="width: 380px">
            <!--begin: Head -->
            <div
              class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
              style="background-image: url(/img/misc/bg-1.jpg)"
            >
              <div class="kt-user-card__avatar">
                <span
                  class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success"
                  >{{ userNameF }}</span
                >
              </div>
              <div class="kt-user-card__name">{{ userName }}</div>
              <!--div class="kt-user-card__badge">
                <span class="btn btn-success btn-sm btn-bold btn-font-md">23 messages</span>
              </div-->
            </div>
            <!--end: Head -->
            <!--begin: Navigation -->
            <div class="kt-notification">
              <a
                href="#"
                @click.prevent="profile"
                class="kt-notification__item"
              >
                <div class="kt-notification__item-icon">
                  <i class="icon-calendar kt-font-success"></i>
                </div>
                <div class="kt-notification__item-details">
                  <div class="kt-notification__item-title kt-font-bold">
                    {{ $t("My Profile") }}
                  </div>
                  <div class="kt-notification__item-time">
                    {{ $t("Account settings and more") }}
                  </div>
                </div>
                <i class="icon-arrow-right" style="color: #a7abc3" />
              </a>
              <div class="kt-notification__custom kt-space-between">
                <a
                  href="#"
                  @click.prevent="logout"
                  target="_blank"
                  class="btn btn-label btn-label-brand btn-sm btn-bold"
                  >{{ $t("Logout") }}</a
                >
              </div>
            </div>
            <!--end: Navigation -->
          </b-dropdown-text>
        </b-dropdown>
      </div>
      <!--end: Language bar -->

      <div class="ws" :title="$t(wsTitle)">
        <div
          class="circle"
          :class="{
            opened: wsStatus == 2,
            error: wsStatus == 3,
            animate: message,
          }"
        ></div>
      </div>
    </div>
    <audio src="/sounds/beep.wav" ref="sound" preload="auto" loop></audio>
    <!-- end: Header Topbar -->
  </div>
  <!-- end:: Header -->
</template>

<script>
import moment from "moment";
import { evbus } from "@/shared/ws";
import MomentsAgo from "@/components/MomentsAgo";
import axios from "axios";

export default {
  components: {
    MomentsAgo,
  },
  data: () => {
    return {
      message: false,
      oldNotifsLength: 0,
      version: "X.XX.X",
      intervalID: 0,
    };
  },
  computed: {
    wsTrafic() {
      const trafic = this.$store.getters["ws/trafic"];
      this.message = false;
      this.$nextTick(() => {
        this.message = true;
      });
      return false;
    },
    wsStatus() {
      return this.$store.getters["ws/status"];
    },
    wsTitle() {
      const status = this.$store.getters["ws/status"];
      if (status == 2) {
        return "Websocket Connected";
      } else if (status == 3) {
        return "Websocket Error";
      }
      return "Websocket Status";
    },
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    flag() {
      return this.lang == "en" ? "flag-icon-gb" : "flag-icon-ro";
    },
    userName() {
      return this.$store.getters["auth/userName"];
    },
    userNameF() {
      const u = this.$store.getters["auth/userName"];
      return u && u.length > 0 ? u[0].toUpperCase() : " ";
    },
    newNotifications() {
      return this.$store.getters["ws/new"];
    },
    notifications() {
      const notifs = this.$store.getters["ws/notifications"];
      if (notifs.length && notifs.length > this.oldNotifsLength) {
        this.oldNotifsLength = notifs.length;
      } else {
        this.oldNotifsLength = notifs.length;
      }
      return notifs;
    },
  },
  mounted() {
    this.websocketAuthorizationCB = this.websocketAuthorization.bind(this);
    evbus.on(
      "ws.notification.authorization_required",
      this.websocketAuthorizationCB
    );
    evbus.on("ws.notification.reprint_required", this.websocketAuthorizationCB);
    evbus.on(
      "ws.notification.authorization_refresh",
      this.websocketAuthorizationCB
    );

    this.websocketActivityCB = this.websocketActivity.bind(this);
    //evbus.on("ws.opened", this.websocketActivityCB);
    evbus.on("ws.error", this.websocketActivityCB);
    //evbus.on("ws.message", this.websocketActivityCB);

    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (
        bvEvent &&
        bvEvent.target &&
        bvEvent.target.classList.contains("notifications-menu")
      ) {
        this.$store.dispatch("ws/clearNewNotifications");
      }
    });

    axios
      .get("/app/package.json?_=" + +new Date())
      .then((resp) => {
        if (resp && resp.data && resp.data.version) {
          this.version = resp.data.version;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  destroyed() {
    this.$root.$off("bv::dropdown::show");
    evbus.remove(
      "ws.notification.authorization_required",
      this.websocketAuthorizationCB
    );
    evbus.remove(
      "ws.notification.reprint_required",
      this.websocketAuthorizationCB
    );
    evbus.remove(
      "ws.notification.authorization_refresh",
      this.websocketAuthorizationCB
    );
    //evbus.remove("ws.opened", this.websocketActivityCB);
    evbus.remove("ws.error", this.websocketActivityCB);
    //evbus.remove("ws.message", this.websocketActivityCB);
  },
  methods: {
    checkIfStillLoggedIn() {
      const self = this;
      self.$store.dispatch("auth/checkMe").catch((err) => {
        self.logout();
      });
    },
    websocketActivity(data, ev) {
      //console.log("DATA", data, "EV", ev);
      this.title = "";
      if (ev === "ws.opened") {
        this.opened = true;
        this.title = "WS Connected";
      } else if (ev === "ws.error") {
        this.opened = false;
        this.error = true;
        this.title = "WS Error";
        this.checkIfStillLoggedIn();
      } else if (ev == "ws.message") {
        this.message = false;
        this.$nextTick(() => {
          this.message = true;
        });
      }
    },
    beep() {
      if (this.$refs.sound) {
        const promiss = this.$refs.sound.play();
        if (promiss !== null) {
          promiss.catch(() => {
            this.$refs.sound.play();
          });
        }
      }
    },
    stopBeep() {
      if (this.$refs.sound) this.$refs.sound.pause();
    },
    websocketAuthorization(data, ev) {
      if (data) {
        if (ev == "ws.notification.authorization_required") {
          data.type = 1;
          this.$store.dispatch("ws/addNotification", data);
        } else if (ev == "ws.notification.reprint_required") {
          data.type = 2;
          this.$store.dispatch("ws/addNotification", data);
        } else if (ev == "ws.notification.authorization_refresh") {
          console.log("ws.notification.authorization_refresh", data);
          if (data.handled) {
            this.$store.dispatch("ws/checkNotifications", data.handled);
          }
          if (typeof data.remaining !== "undefined") {
            if (data.remaining > 0) {
              this.beep();
            } else {
              this.stopBeep();
            }
          }
        }
      }
    },
    sendMessage() {
      this.$emit("close", "kt_header_menu_mobile_close_btn_" + this.i);
      this.i++;
    },
    changeLang(l) {
      return this.$store.dispatch("global/setLanguage", l);
    },
    profile() {
      this.$refs.dropdown.hide(true);
      this.$router.push("/profile");
    },
    logout() {
      this.$refs.dropdown.hide(true);
      this.$store
        .dispatch("auth/logout")
        .then((resp) => {
          this.$router.push("/auth/login");
        })
        .catch((err) => {
          this.$router.push("/auth/login");
        });
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    },
    clearNotifications() {
      this.$store.dispatch("ws/clearNotifications");
    },
  },
};
</script>

<style lang="scss" scoped>
.kt-header__topbar
  .kt-header__topbar-item.kt-header__topbar-item--langs
  .kt-header__topbar-icon
  div {
  border-radius: 50%;
  width: 19px;
}
.flag-header {
  height: 19px;
  background-size: cover;
}
.ws {
  position: absolute;
  width: 10px;
  height: 10px;
  right: 5px;
  top: 5px;

  .circle {
    width: 10px;
    height: 10px;
    background-color: cornflowerblue;
    border-radius: 50%;
  }

  .animate.circle {
    animation: flash-animation 1s ease-in;
  }

  .opened.circle {
    background-color: #41b883;
  }
  .error.circle {
    background-color: #dc3545;
  }

  @keyframes flash-animation {
    0% {
      background-color: #41b883;
    }
    16% {
      background-color: #fff;
    }
    32% {
      background-color: #41b883;
    }
    48% {
      background-color: #fff;
    }
    70% {
      background-color: #41b883;
    }
    86% {
      background-color: #fff;
    }
    100% {
      background-color: #41b883;
    }
  }
}
</style>
